(function($) {
  $('.js-time-ago').each(function() {
    var date = this.dateTime;
    var d = moment(date);
    this.innerHTML = d.fromNow();
  })
})(jQuery);